import React from "react";
import "./About.css";

export default function About() {
  return (
    <section className="about-section">
      <div className="about-inner">

        {/* Left: Image */}
        <div className="about-image-wrap">
          <img
            src="/assets/about.jpeg"
            alt="About Ruga's Cafe"
            className="about-image"
          />
        </div>

        {/* Right: Text */}
        <div className="about-text">
          <h2>About Ruga's Café</h2>

          <p>
            Welcome to Ruga’s Café – proudly brewing the Peninsula’s favourite coffee since 2017. What started as a dream, has turned into a welcoming neighbourhood hangout where fresh food, good coffee and great company come together.
From day one, our mission has been simple; keep it fresh, keep it tasty, and treat everyone like family. 

          </p>

          <p>
            Our menu is built around classic favourites, pastries made in house, and simple ingredients done well.
 Whether you’re just stopping in for a morning brew and bite, joining us for lunch, or ordering for the crew, we have you sorted. Expect fast and friendly service, warm smiles and the occasional bad joke.

          </p>

          <p>
            We are so grateful to the Peninsula for embracing and supporting us since 2017 – you’re the reason we get up early and keep the coffees pouring. Come in, say hi, and feel at home — that’s what we are all about.
          </p>
        </div>

      </div>
    </section>
  );
}
